import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import AddIcon from '@mui/icons-material/Add';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useMutation, useLazyQuery } from '@apollo/client';

import { ADD_MEMBERS } from '../../apis/member';
import { CAN_ADD_TEAM_MEMBERS } from '../../constants/permissions';
import ADD_SKILL from '../../apis/skill';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import useWorkspace from '../../context/WorkspaceContext';

const propTypes = {
  getTeamMembers: PropTypes.func.isRequired,
};

const FadeMenu = ({ getTeamMembers }) => {
  const { setIsLoading } = useLoader();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [Skill, setSkill] = React.useState([]);
  const open = Boolean(anchorEl);
  const { id: projectId } = useParams();
  const [addMembers] = useMutation(ADD_MEMBERS);
  const { userPermissions } = useWorkspace();
  const { undoEdits, setUndoEdits } = useProjectVersionHistory();
  const permissions = [];
  if (userPermissions !== undefined) {
    if (userPermissions.permissions !== undefined) {
      userPermissions.permissions.map((x) => permissions.push(x));
    }
  }
  const handleClose = () => {
    setAnchorEl();
  };
  const getSkillId = async (e) => {
    handleClose();
    setIsLoading(true);
    const variables = {
      input: {
        projectId: parseInt(projectId, 10),
        skillId: e.target.value,
      },
    };
    await addMembers({
      variables,
    });
    if (!undoEdits) setUndoEdits(true);
    getTeamMembers();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [getSkill] = useLazyQuery(ADD_SKILL, { fetchPolicy: 'no-cache' });

  const getSkillMembers = async () => {
    const { error, loading, data } = await getSkill();
    if (!error && !loading && data.skills && !Skill.length) {
      if (data.skills.length > 0) {
        setSkill(data.skills);
      }
    }
  };

  React.useEffect(() => {
    getSkillMembers();
  }, []);

  return (
    <div>
      {permissions.includes(CAN_ADD_TEAM_MEMBERS) && (
        <Button
          className="btn-primary btn-border add-member"
          variant="outlined"
          id="fade-button"
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          startIcon={<AddIcon fontSize="small" />}
        >
          Add Member
        </Button>
      )}
      <Menu
        className="dropdown-add-member"
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {Skill.map((skill) => (
          <MenuItem
            className="dropdown-add-member-item"
            key={skill.id}
            value={`${skill.id}`}
            onClick={(e) => getSkillId(e)}
          >
            {skill.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
FadeMenu.propTypes = propTypes;
export default FadeMenu;
